module.exports = "<div class=\"weui_panel_hd\"><slot></slot></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/panel/panel-header.vue
 ** module id = 150
 ** module chunks = 0
 **/